// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.4142 1H3V23H21V6.58579L15.4142 1ZM14.5 7.5V3L19 7.5H14.5ZM10 16H11L11 11H13L13 16H14V11H16V16C16 17.1046 15.1046 18 14 18H10C8.89543 18 8 17.1046 8 16V11H10V16Z"}}]};

const FileWordFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'file-word-filled',
    ref,
    icon: element,
  },
));

FileWordFilledIcon.displayName = 'FileWordFilledIcon';

export default FileWordFilledIcon;
